import React from "react";
import { Avatar } from "@mui/material";

export default function RoundIconComponent(props) {
  return (
    <Avatar
      sx={{
        backgroundColor: "#DBE5F4",
        height: "50px",
        width: "50px",
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      {props?.children}
    </Avatar>
  );
}
